var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVika(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54177 0.380859L1.64695 2.29964C1.20919 2.51284 0.880859 2.93923 0.880859 3.36563V22.5534C0.880859 22.8732 0.990301 23.193 1.31863 23.4062C1.53751 23.5128 1.75639 23.6194 1.97528 23.6194H2.3036L8.54177 21.8073V0.380859Z",
    fill: "#044D9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9845 1.97984L10.418 0.380859V21.8073L16.9845 23.4062V1.97984Z",
    fill: "#5487C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0845 0.594058C25.8656 0.38086 25.4278 0.380859 25.0995 0.380859L18.8613 2.19304V23.6194L25.7561 21.7007C26.1939 21.5941 26.5222 21.1677 26.5222 20.6347V1.44685C26.5222 1.12705 26.4128 0.807256 26.0845 0.594058Z",
    fill: "#044D9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVika);
export default __webpack_public_path__ + "static/media/vika.288e56856e528f2eacde049aa0521b2a.svg";
export { ForwardRef as ReactComponent };